import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Typography} from "@mui/material";
import css_link from "../Common/css/Link.module.scss";

export default function CCAlertDialog(props: any) {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Bill.com Error
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            An error as occurred. {props.message}<br/>
              <Typography style={{fontSize: "14px", marginTop: "7px"}}><a className={css_link.link} href={props.link}>See exception here</a></Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
  );
}